module.exports = __webpack_public_path__ + "img/code.990a4fb6.png";